import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

// The HEAVY pane — the real Tablero's shape, synthetically: a deliberately expensive mount (a busy
// main-thread block standing in for the board's commit cost, which in dev mode runs hundreds of ms) plus
// a wide grid inside its OWN horizontal scroller with contained overscroll. Its preview mounting
// mid-gesture is the jank source the playground exists to exercise.
export const Route = createFileRoute('/_app/admin/transitions/jobs/$jobId/board')({
  component: BoardPane,
})

function busyBlock(ms: number) {
  const end = performance.now() + ms
  while (performance.now() < end) {
    // deliberate main-thread cost — the playground's whole point
  }
}

function BoardPane() {
  // In the useState initializer so it runs exactly once per MOUNT — each preview mount pays it again,
  // exactly like the real board's commit.
  const [cells] = useState(() => {
    busyBlock(80)
    return Array.from({ length: 30 * 26 }, (_, i) => i)
  })
  return (
    <div className="flex flex-col gap-3 p-4">
      <h2 className="text-lg font-semibold">Board (heavy)</h2>
      <p className="text-muted-foreground text-sm">
        Mounts with an 80ms main-thread block and hosts its own horizontal scroller, like the real board.
      </p>
      <div className="overflow-x-auto [overscroll-behavior-x:none]">
        <div className="grid w-[1100px] grid-cols-[repeat(30,minmax(0,1fr))] gap-1">
          {cells.map((i) => (
            <div
              key={i}
              className="h-7 rounded-sm"
              style={{ backgroundColor: `hsl(${(i * 37) % 360} 70% ${35 + ((i * 13) % 30)}%)` }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
